export enum BackgroundSource {
  NONE = 'none',
  DRONE = 'drone',
  CLASSIFIER = 'classifier'
}
